import React from 'react';
import { Stethoscope, Home, Brain, HeartPulse, Activity, UserCheck } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const services = [
  {
    icon: Stethoscope,
    title: 'Nursing Care',
    description: '24-hour support from qualified nurses for residents with complex medical needs, including medication management and clinical care.',
    color: 'bg-[#1e3a5f]',
    iconColor: 'text-white',
  },
  {
    icon: Home,
    title: 'Residential Care',
    description: 'Support with daily living such as personal care, mobility and companionship in a warm, homely setting.',
    color: 'bg-[#c9a227]',
    iconColor: 'text-[#1e3a5f]',
  },
  {
    icon: Brain,
    title: 'Dementia Nursing',
    description: 'Specialist nursing-led support for residents living with dementia who also have complex clinical needs, delivered by trained nurses in a safe, structured environment.',
    color: 'bg-emerald-600',
    iconColor: 'text-white',
  },
  {
    icon: UserCheck,
    title: 'Dementia Residential',
    description: 'Person-centred residential support for people living with dementia, focused on routine, dignity and meaningful daily activities in a reassuring, homely setting.',
    color: 'bg-[#1e3a5f]',
    iconColor: 'text-white',
  },
  {
    icon: HeartPulse,
    title: 'Mental Health Nursing',
    description: 'Compassionate nursing care for adults living with enduring mental health conditions, supporting wellbeing, recovery and stability with a tailored care plan.',
    color: 'bg-rose-600',
    iconColor: 'text-white',
  },
  {
    icon: Activity,
    title: 'Bariatric Nursing',
    description: 'Specialist nursing care for residents with bariatric needs, with appropriate equipment, mobility support and trained staff to ensure safety, comfort and dignity.',
    color: 'bg-[#c9a227]',
    iconColor: 'text-[#1e3a5f]',
  },
];

const CareServicesSection = () => {
  return (
    <section
      id="services"
      className="py-20 md:py-32 bg-slate-50"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 rounded-full text-[#c9a227] text-sm font-medium mb-6">
            Our Care Services
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a5f] mb-6"
           
          >
            Tailored Care to Meet Every Need
          </h2>
          <p className="text-slate-600 text-lg">
            We provide a full range of care services, tailored to each individual's unique needs and preferences.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card
                key={service.title}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 group cursor-pointer hover:border-[#c9a227]/30"
                data-testid={`service-card-${index}`}
              >
                <CardHeader className="pb-4">
                  <div className={`w-14 h-14 rounded-xl ${service.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                    <IconComponent className={`w-7 h-7 ${service.iconColor}`} />
                  </div>
                  <CardTitle className="text-xl font-bold text-[#1e3a5f]">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-slate-600 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CareServicesSection;
